import isSMIMEItem from './isSMIMEItem';
import { confirm } from 'owa-confirm-dialog';
import loc, { format } from 'owa-localize';
import { infoLinkClickHere } from 'owa-locstrings/lib/strings/infolinkclickhere.locstring.json';
import { ClientItem } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import { SignatureDetails } from 'owa-smime';
import SmimeSignature from 'owa-smime-adapter/lib/store/schema/SmimeSignature';
import * as React from 'react';
import {
    SignatureDetailsDialogText,
    infobarMessageSMIMESenderSignatureValid,
    infobarMessageForMoreInformationText,
} from './getSmimeSignatureInfoBarMessage.locstring.json';
import {
    infobarMessageSMIMESignatureValid,
    infobarMessageSMIMESignatureInvalid,
} from '../strings.locstring.json';
import {
    InfoBarMessageSource,
    InfoBarMessageRank,
    InfoBarMessageViewState,
    MessagePart,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

const styles = require('../components/signatureDetails/Section.scss');

const showSignatureDetails = (smimeSignature: SmimeSignature, isSenderVerified: boolean): void => {
    confirm(loc(SignatureDetailsDialogText), null, false, {
        bodyElement: (
            <SignatureDetails
                certIssuedTo={smimeSignature.CertIssuedTo}
                certIssuedBy={smimeSignature.CertIssuedBy}
                certValidFrom={smimeSignature.CertValidFrom}
                certValidTo={smimeSignature.CertValidTo}
                isSenderVerified={isSenderVerified}
                serverVerificationResult={smimeSignature.ServerVerificationResult}
            />
        ),
        containerClassName: styles.detailsContainer,
        hideCancelButton: true,
    });
};

const getSmimeSignatureInfoBarMessage = (
    message: Message,
    key: string,
    isConversationItemPart: boolean
): InfoBarMessageViewState => {
    const item = message as ClientItem;
    if (
        isConversationItemPart ||
        !(
            isSMIMEItem(item) &&
            item.Smime &&
            item.Smime.Signature &&
            !item.IsDraft
        ) /** Don't show Digital signature verification infobar for draft */
    ) {
        return null;
    }

    const {
        IsHashMatched: isHashMatched,
        IsCertValidToServer: isCertValidToServer,
        CertIssuedTo: certIssuedTo,
    } = item.Smime.Signature;
    const isSenderVerified = isHashMatched && isCertValidToServer;

    let messageString: string = null;
    if (isSenderVerified) {
        if (!certIssuedTo || certIssuedTo.indexOf('=') >= 0) {
            messageString = loc(infobarMessageSMIMESignatureValid);
        } else {
            messageString = format(loc(infobarMessageSMIMESenderSignatureValid), certIssuedTo);
        }
    } else {
        messageString = loc(infobarMessageSMIMESignatureInvalid);
    }

    const messageParts: MessagePart[] = [
        messageString,
        loc(infobarMessageForMoreInformationText),
        {
            text: loc(infoLinkClickHere),
            action: () => showSignatureDetails(item.Smime.Signature, isSenderVerified),
        },
    ];

    return {
        message: messageString,
        messageParts,
        key,
        source: InfoBarMessageSource.ReadingPane,
        rank: isSenderVerified ? InfoBarMessageRank.SmimeSignature : InfoBarMessageRank.Error,
    };
};

export default getSmimeSignatureInfoBarMessage;
